"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _song = _interopRequireDefault(require("../chord_sheet/song"));

var _tag = require("../chord_sheet/tag");

var _constants = require("../constants");

var _parser_warning = _interopRequireDefault(require("./parser_warning"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var NEW_LINE = '\n';
var SQUARE_START = '[';
var SQUARE_END = ']';
var CURLY_START = '{';
var CURLY_END = '}';
var SHARP_SIGN = '#';
/**
 * Parses a ChordPro chord sheet
 */

var ChordProParser = /*#__PURE__*/function () {
  function ChordProParser() {
    _classCallCheck(this, ChordProParser);
  }

  _createClass(ChordProParser, [{
    key: "parse",

    /**
     * Parses a ChordPro chord sheet into a song
     * @param {string} chordProChordSheet the ChordPro chord sheet
     * @returns {Song} The parsed song
     */
    value: function parse(chordProChordSheet) {
      /**
       * All warnings raised during parsing the ChordPro chord sheet
       * @member
       * @type {Array<ParserWarning>}
       */
      this.warnings = [];
      this.song = new _song["default"]();
      this.lineNumber = 1;
      this.sectionType = _constants.NONE;
      this.resetTag();
      this.processor = this.readLyrics;
      this.parseDocument(chordProChordSheet);
      this.song.finish();
      return this.song;
    }
  }, {
    key: "parseDocument",
    value: function parseDocument(document) {
      for (var i = 0, count = document.length; i < count; i += 1) {
        this.processor(document[i]);
      }
    }
  }, {
    key: "readLyrics",
    value: function readLyrics(chr) {
      switch (chr) {
        case SHARP_SIGN:
          this.processor = this.readComment;
          break;

        case NEW_LINE:
          this.lineNumber += 1;
          this.song.addLine();
          this.song.setCurrentLineType(this.sectionType);
          break;

        case SQUARE_START:
          this.song.addChordLyricsPair();
          this.processor = this.readChords;
          break;

        case CURLY_START:
          this.processor = this.readTag;
          break;

        default:
          this.song.lyrics(chr);
      }
    }
  }, {
    key: "readChords",
    value: function readChords(chr) {
      switch (chr) {
        case NEW_LINE:
          break;

        case SQUARE_START:
          break;

        case SQUARE_END:
          this.processor = this.readLyrics;
          break;

        default:
          this.song.chords(chr);
      }
    }
  }, {
    key: "readTag",
    value: function readTag(chr) {
      switch (chr) {
        case CURLY_END:
          this.finishTag();
          this.processor = this.readLyrics;
          break;

        default:
          this.tag += chr;
      }
    }
  }, {
    key: "readComment",
    value: function readComment(chr) {
      switch (chr) {
        case NEW_LINE:
          this.processor = this.readLyrics;
          break;

        default:
          break;
      }
    }
  }, {
    key: "finishTag",
    value: function finishTag() {
      var parsedTag = this.song.addTag(this.tag);
      this.applyTag(parsedTag);
      this.resetTag();
    }
  }, {
    key: "resetTag",
    value: function resetTag() {
      this.tag = '';
    }
  }, {
    key: "applyTag",
    value: function applyTag(tag) {
      switch (tag.name) {
        case _tag.START_OF_CHORUS:
          this.startSection(_constants.CHORUS, tag);
          break;

        case _tag.END_OF_CHORUS:
          this.endSection(_constants.CHORUS, tag);
          break;

        case _tag.START_OF_VERSE:
          this.startSection(_constants.VERSE, tag);
          break;

        case _tag.END_OF_VERSE:
          this.endSection(_constants.VERSE, tag);
          break;

        default:
          break;
      }
    }
  }, {
    key: "startSection",
    value: function startSection(sectionType, tag) {
      this.checkCurrentSectionType(_constants.NONE, tag);
      this.sectionType = sectionType;
    }
  }, {
    key: "endSection",
    value: function endSection(sectionType, tag) {
      this.checkCurrentSectionType(sectionType, tag);
      this.sectionType = _constants.NONE;
      this.song.setCurrentLineType(this.sectionType);
    }
  }, {
    key: "checkCurrentSectionType",
    value: function checkCurrentSectionType(sectionType, tag) {
      if (this.sectionType !== sectionType) {
        this.addWarning("Unexpected tag {".concat(tag.originalName, ", current section is: ").concat(this.sectionType));
      }
    }
  }, {
    key: "addWarning",
    value: function addWarning(message) {
      var warning = new _parser_warning["default"](message, this.lineNumber);
      this.warnings.push(warning);
    }
  }]);

  return ChordProParser;
}();

var _default = ChordProParser;
exports["default"] = _default;